import Backbone from 'backbone'
import AdminConnections from './admin-connections'
import globals from 'scoreboard/components/globals'
import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'
import DatabaseWizard from './scoreboard-db-wizard'
import Database from './database'
import $ from 'jquery'
import unwrapModel from 'scoreboard/components/unwrap-model'
import RefreshButton from 'scoreboard/components/refresh-button'

var AdminScoreboardDatabases = AdminConnections.extend({
	className: AdminConnections.prototype.className + ' admin-impact-databases',

	heading: 'admin.importConnections.impact.short',

	Model: Database,

	events: _.extend({}, AdminConnections.prototype.events, {
		'click .refresh-button': 'rebuildIndexes'
	}),

	/**
	 * Admin | Scoreboard Databases screen
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Array} options.connections a plain JavaScript array holding the
	 * connections
	 */
	initialize(options = {}) {
		AdminConnections.prototype.initialize.apply(this, arguments)
		// these 2 events are triggered in scoreboard-db-wizard.js:finish
		Backbone.on('add:database', this._onAdd.bind(this))
		Backbone.on('edit:database', this._onEdit.bind(this))
		this.on('delete', connection => Backbone.trigger('delete:database', connection))
	},

	render() {
		AdminConnections.prototype.render.apply(this, arguments)
		this.renderPanel('scoreboard')
		return this
	},

	renderPanel(type) {
		AdminConnections.prototype.renderPanel.apply(this, arguments)

		if (type === 'scoreboard') {
			if (globals.database && globals.database.id) {
				// #18452 - Don't allow disabling or deleting the currently logged in database because there's
				// no way to change the database you're logged into on the server or client
				// By nature, this also handles the last remaining database
				this.$(`.panel ul.list li[data-id=${globals.database.id}].online`)
					.find('.toggle-connection, .delete').addClass('is-not-displayed')
			}
		}
	},

	rowContext(connection) {
		let context = AdminConnections.prototype.rowContext.apply(this, arguments)
		var statusCtx = {}
		statusCtx.icon = 'database' // Icon type
		if (connection.licenseExpired) {
			statusCtx.banner = 'banner-error'
			statusCtx.licenseStatus = 'license-expired'
			statusCtx.licenseMessage = i18n.get('admin.databaseConnections.licenseExpired')
		} else if (connection.licenseUsageExceeded || connection.licenseLinkageExceeded) {
			statusCtx.banner = 'banner-warning'
			statusCtx.licenseStatus = 'license-exceeded'
			statusCtx.licenseMessage = i18n.get('admin.databaseConnections.licenseUsageExceeded')
			if (connection.licenseLinkageExceeded) {
				statusCtx.licenseMessage = i18n.get('admin.databaseConnections.licenseLinkageExceeded')
			}
		}
		return _.extend(context, statusCtx)
	},

	// when the user clicks on add database
	add: function(e) {
		var type = $(e.target).closest('.panel').data('type')
		var model = new Database({ standard: true, type })
		new DatabaseWizard({ model }).start()
	},

	edit: function(e) {
		var id = this._itemId(e)
		var model = new Database(this._item(id))
		new DatabaseWizard({ model }).resume()
	},

	rebuildIndexes: function(e) {
		var target = $(e.currentTarget)
		let refreshButton = new RefreshButton({
			el: target,
			actionsContainer: target.closest('.actions-container')
		})
		refreshButton.loading()

		$.post('api/admin/databases/' + this._itemId(e) + '/rebuild-indexes', () => {
			refreshButton.done()
		})
	},

	_onEdit(connection) {
		AdminConnections.prototype._onEdit.apply(this, arguments)
		connection = unwrapModel(connection)
		$.get('api/admin/databases', connections => {
			this.collection = connections
			this.render()
			if (connection.licenseUsageExceeded) {
				this.error(connection, 'admin.databaseConnections.update.licenseUsageExceeded')
			}
			if (connection.licenseLinkageExceeded) {
				this.error(connection, 'admin.databaseConnections.update.licenseLinkageExceeded')
			}
			if (connection.licenseExpired) {
				this.error(connection, 'admin.databaseConnections.update.licenseExpired')
			}
		})
	},

	error(connection, message) {
		connection = unwrapModel(connection)
		this.$el.addClass('has-error')
		this.$('.banner-error').append(`<div>${_.escape(i18n.get(message, connection.label))}</div>`)
	}

})

export default AdminScoreboardDatabases

AdminScoreboardDatabases.__filename__ = 'admin/connections/admin-impact-databases.js'
